import './news-highlight-text.scss';

/**
 * version    1.0
 * class      <type> (news heading)
 * classdesc
 */
export class NewsHighlightText {}
